import { getAddMemberModalTitle } from 'features/Timeline/components/TimelineTeamMemberControlAdd/addMemberModalTitle'
import { TimelineTeamMemberFormAdd } from 'features/Timeline/components/TimelineTeamMemberControlAdd/TimelineTeamMemberFormAdd'
import { UIModal } from 'features/UI'
import { useShowControl } from 'hooks/useShowControl'
import { useEffect } from 'react'
import { TeamMember, TeamType } from 'types'

interface TeamsPageMemberControlAddProps {
  teamId: number | null
  teamName: string | null
  teamType: TeamType | null
  organizationId: number | null
  teamMembersData: TeamMember[]
  onRefetchTeamMembers: () => Promise<void>
  onClose: () => void
}

export function TeamsPageMemberControlAdd({
  teamId,
  teamName,
  teamType,
  organizationId,
  teamMembersData,
  onRefetchTeamMembers,
  onClose,
}: TeamsPageMemberControlAddProps) {
  const [isOpen, handleOpen, handleClose] = useShowControl()

  // Automatically open modal when teamId changes
  useEffect(() => {
    if (teamId) {
      handleOpen()
    }
  }, [teamId, handleOpen])

  const handleModalClose = () => {
    handleClose()
    onClose() // Reset teamId in parent
  }

  if (!teamId) return null

  return (
    <UIModal
      title={getAddMemberModalTitle(teamName, teamType)}
      width={800}
      isOpen={isOpen}
      onClose={handleModalClose}
    >
      <TimelineTeamMemberFormAdd
        onClose={handleModalClose}
        teamId={teamId}
        teamMembersData={teamMembersData}
        organizationId={organizationId || undefined}
        onRefetchTeamMembers={onRefetchTeamMembers}
      />
    </UIModal>
  )
}
